import { render, staticRenderFns } from "./revt_baseinfo.vue?vue&type=template&id=44f3637a&scoped=true"
import script from "./revt_baseinfo.vue?vue&type=script&lang=js"
export * from "./revt_baseinfo.vue?vue&type=script&lang=js"
import style0 from "./revt_baseinfo.vue?vue&type=style&index=0&id=44f3637a&prod&lang=css"
import style1 from "./revt_baseinfo.vue?vue&type=style&index=1&id=44f3637a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f3637a",
  null
  
)

export default component.exports